import styled from "styled-components";

export const PortfolioGalleryWrapper = styled.section`
  margin-bottom: 10rem;
`;

export const PortfolioGalleryDate = styled.span`
  color: var(--color-white);
  font-size: 1.4rem;
`;
